import React, { useId } from 'react';

/** Tubo ondulado 3D (estilo referencia) — trazo continuo tipo “m” con gradiente durazno → rosa → lavanda */
const TUBE_PATH =
  'M4 21.5V11.2c0-4.6 3.6-6.4 7-3 2 2.1 2.6 5.7 5.3 5.7 2.7 0 3-5.1 6.3-6.1 3.6-1.1 6.4 2.2 7.5 6.4 1 3.9 4.2 5.7 8.1 3.8';

export default function BrandLogoMark({ className = '' }) {
  const uid = useId().replace(/:/g, '');
  const grad = `brandTubeGrad-${uid}`;
  const shine = `brandTubeShine-${uid}`;
  const shadow = `brandTubeShadow-${uid}`;

  const rootClass = ['np-logo-mark-svg', className].filter(Boolean).join(' ');

  return (
    <svg
      className={rootClass}
      viewBox="0 0 52 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={grad} x1="0%" y1="50%" x2="100%" y2="50%">
          <stop offset="0%" stopColor="#ffc8a0" />
          <stop offset="32%" stopColor="#ff7eb3" />
          <stop offset="58%" stopColor="#e056fd" />
          <stop offset="100%" stopColor="#9ec5ff" />
        </linearGradient>
        <linearGradient id={shine} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.55)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
        <filter id={shadow} x="-20%" y="-30%" width="140%" height="160%">
          <feDropShadow dx="0" dy="1.2" stdDeviation="1.2" floodColor="#6b2148" floodOpacity="0.35" />
        </filter>
      </defs>
      <path
        d={TUBE_PATH}
        stroke="#7c2d5a"
        strokeWidth="9.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.28"
        transform="translate(0 1.1)"
      />
      <path
        d={TUBE_PATH}
        stroke={`url(#${grad})`}
        strokeWidth="7.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={`url(#${shadow})`}
      />
      <path
        d={TUBE_PATH}
        stroke={`url(#${shine})`}
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(0 -0.6)"
        opacity="0.85"
      />
    </svg>
  );
}
